import axios from "axios"
import baseUrl from "./base"

const mainApi = {
  get: async () => {
    return await axios.post(`${baseUrl}/api`)
  },
  fetchAppVersion: async () => {
    return await axios.get(`${baseUrl}/api/version`)
  }
}

export default mainApi